export const selectStripeCustomer = (state) =>
  state.stripe.customer.stripeCustomer;

export const selectIsLoadingStripeCustomer = (state) =>
  state.stripe.customer.isLoading;
